module.exports = __webpack_public_path__ + "Kaitak_LP_Photo-min.7508430c75be32afa88e.png";